// extracted by mini-css-extract-plugin
export default {"activity":"ServicesPageActivitiesComponent_activity__2ExDI"};